/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svtag_SocketInputs */

const en_svtag_socket = /** @type {(inputs: Svtag_SocketInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SOCKET`)
};

const ar_svtag_socket = /** @type {(inputs: Svtag_SocketInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#مأخذ`)
};

const bn_svtag_socket = /** @type {(inputs: Svtag_SocketInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SOCKET`)
};

const de_svtag_socket = /** @type {(inputs: Svtag_SocketInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SOCKET`)
};

const es_svtag_socket = /** @type {(inputs: Svtag_SocketInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SOCKET`)
};

const fr_svtag_socket = /** @type {(inputs: Svtag_SocketInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SOCKET`)
};

const pt_svtag_socket = /** @type {(inputs: Svtag_SocketInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SOCKET`)
};

const zh_svtag_socket = /** @type {(inputs: Svtag_SocketInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SOCKET`)
};

const tr_svtag_socket = /** @type {(inputs: Svtag_SocketInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SOCKET`)
};

const ru_svtag_socket = /** @type {(inputs: Svtag_SocketInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SOCKET`)
};

const pl_svtag_socket = /** @type {(inputs: Svtag_SocketInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SOCKET`)
};

/**
* | output |
* | --- |
* | "#SOCKET" |
*
* @param {Svtag_SocketInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svtag_socket = /** @type {((inputs?: Svtag_SocketInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svtag_SocketInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svtag_socket(inputs)
	if (locale === "bn") return bn_svtag_socket(inputs)
	if (locale === "de") return de_svtag_socket(inputs)
	if (locale === "es") return es_svtag_socket(inputs)
	if (locale === "fr") return fr_svtag_socket(inputs)
	if (locale === "pt") return pt_svtag_socket(inputs)
	if (locale === "zh") return zh_svtag_socket(inputs)
	if (locale === "tr") return tr_svtag_socket(inputs)
	if (locale === "ru") return ru_svtag_socket(inputs)
	if (locale === "pl") return pl_svtag_socket(inputs)
	return en_svtag_socket(inputs)
});